import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _get from "lodash/get";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { getCreditFactorHistory, getCreditProfileRecentChanges, getCreditProfileAlerts } from "../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, getCreditFactorHistory.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _defineProperty(_createReducer, getCreditProfileRecentChanges.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    recent_changes: _get(payload, 'recent_changes'),
    no_changes_data: _get(payload, 'no_changes_data')
  });
}), _defineProperty(_createReducer, getCreditProfileAlerts.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _createReducer), {});